import { get } from 'lodash';
import { call, put, take, fork } from 'redux-saga/effects';

import {
	GET_CHIMERA_CONFIG,
	GET_CHIMERA_CONFIG_SUCCESS,
	GET_CHIMERA_CONFIG_ERROR,
} from '@/redux/ducks/userConfig/types';
import { INIT_APP_ERROR } from '@/redux/ducks/init/types';
import { filterUserConfigData, getFingerprintCookie } from '@/utils/helper';
import constants from '@/utils/constants';
import api from '@/data';
import { defaultChimeraConfig } from '@/constants';
const { BUILD_NUMBER, BUILD_TIMESTAMP } = constants;

export function* getConfig(merchantId) {
	try {
		const keys = Object.keys(defaultChimeraConfig).map((key) => ({ key }));
		const payload = {
			appContext: {
				deviceId: getFingerprintCookie(),
				appversion: BUILD_NUMBER,
				deviceModel: 'Web',
				buildGenerationTime: BUILD_TIMESTAMP,
			},
			keyCrisp: keys,
			maxSize: Object.keys(defaultChimeraConfig).length,
			merchantId,
		};
		const response = yield call(api.getChimeraConfig, payload);
		const userConfigData = filterUserConfigData(get(response, 'data', {}));
		yield put({
			type: GET_CHIMERA_CONFIG_SUCCESS,
			data: userConfigData,
		});
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: GET_CHIMERA_CONFIG_ERROR, error: error.data });
		}
	}
}

export function* getConfigWatcher() {
	while (true) {
		const { merchantId } = yield take(GET_CHIMERA_CONFIG);
		yield fork(getConfig, merchantId);
	}
}

function* userConfigSaga() {
	yield fork(getConfigWatcher);
}

export default userConfigSaga;
